import { render, staticRenderFns } from "./Propagandist.vue?vue&type=template&id=63f86c2c&"
import script from "./Propagandist.vue?vue&type=script&lang=js&"
export * from "./Propagandist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports